import React, { FC } from 'react';
import { Link } from '@/i18n/routing';
import { Routes } from '@/lib/routes/routes';
import { Section } from '../../CMSComponents/services/types';
import Image from '@/components/Image';
import { useLocale } from 'next-intl';

type Props = {
  data: Section;
};

const DigitalCardLink: FC<Props> = ({ data }) => {
  const local = useLocale();
  const digitalARCardImage = JSON.parse(data.content).ArabicImage;
  const digitalENCardImage = JSON.parse(data.content).EnglishImage;

  const renderImage = local === 'ar' ? digitalARCardImage : digitalENCardImage;

  return (
    <section className="aspect-[2.5/1] overflow-hidden rounded-3xl">
      <Link href={Routes.digitalCards}>
        <div className="relative h-full w-full overflow-hidden rounded-2xl drop-shadow-md">
          <Image
            src={renderImage}
            alt="Digital Cards"
            fill
            className="object-contain"
            quality={100}
          />
        </div>
        {/* <div className="grid grid-cols-12 place-items-center">

          <div className="col-span-6">
            <h2 className="text-xl font-extrabold tracking-wider text-white md:text-3xl lg:text-4xl">
              {data.name}
            </h2>
          </div>
  
          <div className="relative col-span-6 aspect-[3.5/2] h-full w-full">
            <Image
              src={renderImage}
              alt="Digital Cards"
              fill
              className="object-contain transition-all duration-300 group-hover:scale-95"
            />
          </div>
        </div> */}
      </Link>
    </section>
  );
};

export default DigitalCardLink;
